import React, { useEffect, useState } from "react";
import FundraisingAPI from "Lib/API/Fundraising";
import "./DonorWall.scss";

const LIMIT = 12;

const initials = name => {
  if (!name) return "?";
  return name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
};

const COLORS = ["#2455ef","#7c3aed","#db2777","#059669","#d97706","#0891b2"];
const avatarColor = name => COLORS[(name || "?").charCodeAt(0) % COLORS.length];

const DonorWall = ({ campaignId, refreshTrigger, orgCountry }) => {
  const fmtAmount = n =>
    Number(n || 0).toLocaleString(orgCountry?.local || "en-US", {
      style: "currency", currency: orgCountry?.currency || "USD", maximumFractionDigits: 0,
    });
  const [donors, setDonors] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const load = (p = 1) => {
    setLoading(true);
    FundraisingAPI.getDonors(campaignId, p, LIMIT)
      .then(res => {
        const data = res;
        setDonors(prev => (p === 1 ? data.donors : [...prev, ...data.donors]));
        setTotal(data.total);
        setPage(p);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (campaignId) load(1);
  }, [campaignId, refreshTrigger]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!loading && !donors.length) return null;

  return (
    <div className="dw">
      {loading && donors.length === 0 ? (
        <div className="dw-loading">
          {[...Array(4)].map((_, i) => <div key={i} className="dw-skeleton" />)}
        </div>
      ) : (
        <div className="dw-grid">
          {donors.map((d, i) => (
            <div key={i} className="dw-card">
              <div
                className="dw-card__avatar"
                style={d.anonymous ? {} : { background: avatarColor(d.name) }}
              >
                {d.anonymous ? "🎗" : initials(d.name)}
              </div>
              <div className="dw-card__info">
                <span className="dw-card__name">
                  {d.anonymous ? "Anonymous" : d.name || "Donor"}
                  {d.pending && <span className="dw-card__pending">Pending</span>}
                </span>
                <span className="dw-card__amount">
                  {fmtAmount(d.amount)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {donors.length < total && (
        <div className="dw-more">
          <button
            className="dw-more__btn"
            onClick={() => load(page + 1)}
            disabled={loading}
          >
            {loading ? "Loading…" : `Show more (${total - donors.length} remaining)`}
          </button>
        </div>
      )}
    </div>
  );
};

export default DonorWall;
